// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__gFx9B","pageButton":"pagination_pageButton__+Qj+K","active":"pagination_active__TFXf8","ellipsis":"pagination_ellipsis__bC20d"};